import styled from "styled-components";

const StyledLeadership = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  right: 70px;
  top: 190px;
  z-index: 3;

  .title {
    position: absolute;
    font-size: 18px;
    bottom: 100px;
  }

  .svgIcon {
    margin: 40px;
    right: 0;
    width: 300px;
    transform: scale(1.4);
  }
`;

export const StyledSung = styled.div`
  position: absolute;
  z-index: 3;
  .sungIcon {
    width: 150px;
    height: 150px;
    /* position: absolute; */
  }
`;

export default StyledLeadership;
